import React, { ReactNode, Children } from 'react';
import styled from 'styled-components';
import flattenChildren from 'react-keyed-flatten-children';

import { Box } from '../Box';
import { spaces } from '../../settings';
import { ResponsiveProp } from '../../lib/responsiveProps';

export interface StackProps {
    children: ReactNode;
    space: ResponsiveProp<spaces.Space>;
}

const BoxItem = styled(Box)`
    :last-child {
        padding-bottom: 0;
    }
`;

export function Stack({ children, space }: StackProps) {
    const stackItems = flattenChildren(children);

    return (
        <Box>
            {Children.map(stackItems, (child) =>
                child !== null && child !== undefined ? (
                    <BoxItem paddingBottom={space}>{child}</BoxItem>
                ) : null
            )}
        </Box>
    );
}
